var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermostat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 48.4,
    height: 48.4,
    rx: 8.2,
    stroke: "#F57F20",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6507 33.7043C18.6507 32.0594 19.5472 30.5237 20.9905 29.6951L21.3765 29.4737V14.5954C21.3765 13.5299 22.252 12.6622 23.328 12.6622C24.404 12.6622 25.2794 13.5299 25.2794 14.5954V29.4737L25.6659 29.6951C27.1087 30.5232 28.0052 32.0594 28.0052 33.7043C28.0052 36.2592 25.9069 38.3379 23.328 38.3379C20.7486 38.3379 18.6507 36.2592 18.6507 33.7043ZM26.8856 14.5002C26.8856 12.5701 25.2895 11 23.3281 11C21.3666 11 19.7705 12.5701 19.7705 14.5002V28.6295C18.0572 29.7814 17 31.7353 17 33.7737C17 37.2069 19.8386 40 23.3281 40C26.8175 40 29.6561 37.2069 29.6561 33.7737C29.6561 31.7353 28.5984 29.7809 26.8856 28.6295V14.5002ZM32.2261 21.1367H28.821C28.3944 21.1367 28.0476 21.5098 28.0476 21.9681C28.0476 22.4264 28.3944 22.7989 28.821 22.7989H32.2261C32.6528 22.7989 33 22.4264 33 21.9681C33 21.5098 32.6528 21.1367 32.2261 21.1367ZM28.821 24.5745H32.2261C32.6528 24.5745 33 24.9475 33 25.4058C33 25.8641 32.6528 26.2367 32.2261 26.2367H28.821C28.3944 26.2367 28.0476 25.8641 28.0476 25.4058C28.0476 24.9475 28.3944 24.5745 28.821 24.5745ZM32.1838 14.2614H28.7787C28.3521 14.2614 28.0053 14.6345 28.0053 15.0928C28.0053 15.5511 28.3521 15.9236 28.7787 15.9236H32.1838C32.6104 15.9236 32.9577 15.5511 32.9577 15.0928C32.9577 14.6345 32.6104 14.2614 32.1838 14.2614ZM28.7787 17.6991H32.1838C32.6104 17.6991 32.9577 18.0721 32.9577 18.5304C32.9577 18.9887 32.6104 19.3613 32.1838 19.3613H28.7787C28.3521 19.3613 28.0053 18.9887 28.0053 18.5304C28.0053 18.0721 28.3521 17.6991 28.7787 17.6991Z",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/Thermostat.8486a6691a45cca41069d8c69c993720.svg";
export { ForwardRef as ReactComponent };